import axios from 'axios';

export const PhotoService = (function () {
  let instance;
  // const BASE_URI = 'base service uri'

  function init() {
    return {
      getImages: async function () {
        const {
          data: { data },
        } = await axios.get('assets/demo/data/photos.json');
        return data;
      },
    };
  }

  return {
    getInstance: function () {
      if (!instance) instance = init();
      return instance;
    },
  };
})();
